import React from 'react';
import { motion } from 'framer-motion';
interface OrbitFieldProps {
  className?: string;
  /** Number of orbits to draw */
  count?: number;
  /** Center position as percentages: { x, y } */
  center?: {
    x: number;
    y: number;
  };
  size?: number;
}
/**
 * Lightweight orbital field — small set of tilted rings with particles
 * traveling on them. Used as a section decoration. Less heavy than the
 * full SplineScene hero animation.
 */
export function OrbitField({
  className = '',
  count = 3,
  center = {
    x: 50,
    y: 50
  },
  size = 400
}: OrbitFieldProps) {
  const orbits = Array.from({
    length: count
  }).map((_, i) => ({
    rx: size * (0.6 + i * 0.2),
    ry: size * (0.2 + i * 0.1),
    rotate: i * 30,
    dur: 14 + i * 6,
    opacity: 0.3 - i * 0.05,
    particles: 2 + i
  }));
  return <div className={`absolute pointer-events-none ${className}`} style={{
    left: `${center.x}%`,
    top: `${center.y}%`,
    width: 0,
    height: 0,
    perspective: '1200px'
  }} data-id="element-219">
      {/* Center dot */}
      <div className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#1a8fd4]" style={{
      width: 6,
      height: 6,
      boxShadow: '0 0 20px #1a8fd4, 0 0 40px rgba(26,143,212,0.5)'
    }} data-id="element-220" />

      {orbits.map((orbit, idx) => <motion.div key={idx} className="absolute -translate-x-1/2 -translate-y-1/2 flex items-center justify-center" style={{
      width: orbit.rx,
      height: orbit.ry,
      transform: `translate(-50%, -50%) rotateZ(${orbit.rotate}deg) rotateX(75deg)`,
      transformStyle: 'preserve-3d'
    }} animate={{
      rotateY: 360
    }} transition={{
      duration: orbit.dur,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-221">
          <div className="absolute inset-0 rounded-full border" style={{
        borderColor: `rgba(26,143,212,${orbit.opacity})`
      }} data-id="element-222" />
          {Array.from({
        length: orbit.particles
      }).map((_, p) => {
        const angle = 360 / orbit.particles * p;
        return <div key={p} className="absolute" style={{
          width: 4,
          height: 4,
          left: '50%',
          top: '50%',
          transform: `translate(-50%, -50%) rotate(${angle}deg) translateX(${orbit.rx / 2}px)`
        }} data-id="element-223">
                <div className="w-1.5 h-1.5 rounded-full bg-[#1a8fd4]" style={{
            boxShadow: '0 0 8px #1a8fd4'
          }} data-id="element-224" />
              </div>;
      })}
        </motion.div>)}
    </div>;
}